import { IDinamikBilesenMeta } from '../interfaces/IDinamikBilesen.interface';
import { DinamikBilesenRegistry } from '../src/lib/dinamik-bilesen/dinamik-bilesen.registry';

export function DinamikBilesen(meta: IDinamikBilesenMeta) {
  const frozenMeta = Object.freeze({ ...meta });

  return function (target: any) {
    if (DinamikBilesenRegistry.varMi(frozenMeta.id)) {
      console.warn(`[DinamikBilesen] '${frozenMeta.id}' zaten kayıtlı, üzerine yazılıyor.`);
    }

    Object.defineProperty(target, 'bilesen_id', { value: frozenMeta.id, writable: false, configurable: false });
    Object.defineProperty(target.prototype, 'bilesen_id', { value: frozenMeta.id, writable: false, configurable: false });
    Object.defineProperty(target.prototype, 'meta', { value: frozenMeta, writable: false, configurable: false });

    const instance = new target();

    DinamikBilesenRegistry.kaydet(frozenMeta.id, instance, frozenMeta);
  };
}
